// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"e540ed85","125":"c537ea98","343":"4c809a33"}[chunkId] + ".chunk.js";
};